import React from 'react';

import { Select, SelectProps } from '@yandex-360/orb-components/dist/components/Select2';

import css from './styles.css';

export type SettingsSelectProps<T> = SelectProps<T> & {
    popupClassName?: string;
};

export const SettingsSelect = <T,>({ className, popupClassName, popupProps, ...props }: SettingsSelectProps<T>) => {
    const buttonClass = className ? `${css.selectButton} ${className}` : css.selectButton;
    const popupClass = popupClassName ?? css.selectPopup;

    return (
        <Select
            {...props}
            className={buttonClass}
            popupProps={{
                ...popupProps,
                className: popupClass,
            }}
        />
    );
};
